import { createSlice } from "@reduxjs/toolkit";
import { accessEvents } from "../../actions/events/accessEvents";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const accessEventsReducer = createSlice({
  name: "accessEvents",
  initialState,
  reducers: {
    // cleargetCategoriessState: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(accessEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(accessEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(accessEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// export const { cleargetCategoriessState } = getCategoriessSlice.actions;
export default accessEventsReducer.reducer;
